import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CloseIcon = createIcon({
  displayName: 'CloseIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M17.25 6.75L6.75 17.25'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M6.75 6.75L17.25 17.25'
    />
  ],
  defaultProps: defaultProps
})
